import { useEffect, useState } from "react";
import useLenis from "@/hooks/useLenis";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Manifesto from "@/components/Manifesto";
import TextMarquee from "@/components/Marquee";
import Collections from "@/components/Collections";
import CollectionSection from "@/components/CollectionSection";
import Signup from "@/components/Signup";
import Footer from "@/components/Footer";
import BackToTop from "@/components/BackToTop";
import { api } from "@/lib/api";
import { useContent } from "@/lib/content";

const LAYOUT = {
  originals: {
    heroImg:
      "https://images.unsplash.com/photo-1559697242-a465f2578a95?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    inverted: false,
    reverse: false,
  },
  faucet: {
    heroImg:
      "https://images.unsplash.com/photo-1647664856968-880b8eccd588?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    inverted: true,
    reverse: true,
  },
  skate: {
    heroImg:
      "https://images.unsplash.com/photo-1649281610716-94e4ee026d91?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    inverted: false,
    reverse: false,
  },
  goods: {
    heroImg:
      "https://images.pexels.com/photos/10132110/pexels-photo-10132110.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
    inverted: true,
    reverse: true,
  },
};

const ALL_COLLECTIONS = ["originals", "faucet", "skate", "goods"];
const CHAPTER_LABELS = ["01", "02", "03", "04", "05", "06"];

export default function Landing() {
  useLenis();
  const { t } = useContent();
  const [grouped, setGrouped] = useState({});

  const order = t("collection_order")
    .split(",")
    .map((s) => s.trim())
    .filter((c) => ALL_COLLECTIONS.includes(c));
  const ORDER = [...order, ...ALL_COLLECTIONS.filter((c) => !order.includes(c))];

  useEffect(() => {
    api.get("/products").then(({ data }) => {
      const g = {};
      data.products.forEach((p) => {
        (g[p.collection] = g[p.collection] || []).push(p);
      });
      setGrouped(g);
    });
  }, []);

  useEffect(() => {
    if (Object.keys(grouped).length && window.location.hash) {
      const id = window.location.hash.slice(1);
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 300);
    }
  }, [grouped]);

  const jumpToSignup = () =>
    document.getElementById("signup")?.scrollIntoView({ behavior: "smooth" });

  return (
    <main data-testid="landing-page" className="w-full overflow-hidden bg-[#F2EFEB]">
      <Nav />
      <Hero onJoin={jumpToSignup} />
      <TextMarquee inverted={false} />
      <Manifesto />
      <Collections />
      {ORDER.map((key, i) => (
        <CollectionSection
          key={key}
          id={key}
          index={i}
          chapter={CHAPTER_LABELS[i]}
          title={t(`col_${key}_title`)}
          tagline={t(`col_${key}_tagline`)}
          description={t(`col_${key}_desc`)}
          heroImg={t(`media_${key}`)}
          inverted={i % 2 === 1}
          reverse={i % 2 === 1}
          products={grouped[key] || []}
        />
      ))}
      <TextMarquee inverted={true} />
      <Signup />
      <Footer />
      <BackToTop />
    </main>
  );
}
